/* jshint node:true */
'use strict';

var React = require('react');

/* Components */
var LeagueTable         = require('./LeagueTable.jsx');
var NewsList            = require('./NewsList.jsx');
var Commentary          = require('./Commentary.jsx');
var PlayerList          = require('./PlayerList.jsx');
var GameInformation     = require('./GameInformation.jsx');
var Advert = require('../../common/Advert.jsx');
var AdReloaderMixin = require('../../../mixins/AdReloaderMixin.js');

var TabCommentary = React.createClass({

    displayName: 'TabCommentary',

    mixins : [ AdReloaderMixin ],

    getInitialState : function(){
        return {
            adWrapSelector : '#reactContainer .react-ad'
        };
    },

    render: function () {

        var oStore      = this.props.store;
        var sState      = this.props.matchState || [];

        /* Load in the data from the Store */
        var aLeagueTable    = oStore.getLeagueTable();
        var newsList        = oStore.getNewsList();
        var aCommentary     = oStore.getCommentary();
        var aHomeTeam       = oStore.getPlayersList('home');
        var aAwayTeam       = oStore.getPlayersList('away');
        var oHomeTeam       = oStore.getHomeTeam();
        var oAwayTeam       = oStore.getAwayTeam();
        var oGameInfo       = oStore.getGameInformation();
        var sLeagueName     = oStore.getLeagueName();

        return (
            <div className="layout-cbc">
                <section className="col-one">
                    <PlayerList homeTeam={aHomeTeam} awayTeam={aAwayTeam} matchState={sState} home={oHomeTeam} away={oAwayTeam} />
                    <GameInformation capacity={oGameInfo.capacity} attendance={oGameInfo.attendance} datetime={oGameInfo.datetime} coverage={oGameInfo.coverage} venue={oGameInfo.venueName} address={oGameInfo.address}/>
                </section>
                <section className="col-two">
                    <Commentary gameEvents={aCommentary} showAll={true}/>
                </section>
                <section id="now-feed" className="col-three">
                    <article className="ad-300">
                        <div className="ad-center">
                            <Advert id='game.rhs.mpu' className="ad-slot-incontent ad-wrapper" slotType="incontent" />
                        </div>
                    </article>
                    <LeagueTable tableHref={this.props.tableHref} date="" name={sLeagueName} table={aLeagueTable} />
                    <NewsList header={newsList.header} link={newsList.link} articles={newsList.articles} />
                </section>
            </div>
        );
    }
});

module.exports = TabCommentary;







/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/TabCommentary.jsx
 **/